import { useQuery } from "react-query";
import teamService from "../../services/teamService";
import queryKeys from "../../constants/queryKeys";

const useELTeams = ({ accountExternalIds }) =>
    useQuery(
        [queryKeys.eLTeams, accountExternalIds.join(",")],
        () => teamService.getELTeams(accountExternalIds),
        {
            enabled: !!accountExternalIds?.length,
        }
    );

export default useELTeams;
